import { Slideover } from "tailwindcss-stimulus-components";

export default class extends Slideover {
  static targets = ["selector", "card"];

  open(e){
    const topPosition = e.target.getBoundingClientRect().y;
    // const rightPosition = e.target.getBoundingClientRect().x;

    const selectorHeight = 40;
    const Ypos = `${topPosition - (selectorHeight / 2)}px`;

    this.selectorTarget.style.top = Ypos;
    this.cardTarget.style.top = Ypos;
    super.open();
  }
}
